// Module
var code = "<div class=\"booking-info__data\"> <ul class=\"booking-info__data__items inter regular p3\"></ul> </div> <a href=\"\" class=\"booking-info__cta uppercase p3 regular\" data-translation-id=\"28\">prenota</a> <template id=\"booking-info__item-template\"> <li class=\"booking-info__data__items__item\"></li> </template> ";
// Exports
export default code;